import { createAction, createActionGroup, props } from "@ngrx/store";
import { Auth } from "../../auth/primitives/auth";
import { Vector2, Vector3 } from "three";

export const worldActions = createActionGroup({
  source: "World",
  events: {
    "Binst View Started": props<{ viewId: string }>(),
    "Binst View Ready": props<{ viewId: string }>(),
    "Networking Ready": props<{ viewId: string }>(),
    "Three Renderer Ready": props<{ viewId: string }>(),
    "Pixi Renderer Ready": props<{ viewId: string }>(),
    "Surfaces Ready": props<{ viewId: string }>(),
    "Surface Debugging toggled": props<{ enabled: boolean }>(),
    "Timer Ticked 10s": props<{ currentTick: number }>(),
    "Timer Ticked 3s": props<{ currentTick: number }>(),
    "Set debug value": props<{ key: string, value: any }>(),
  },
});
